const auditLogEntities = {};

/**
 * Returns all audit log entities.
 * @param {Object} state
 * @returns {Object[]} audit log entities
 */
auditLogEntities.get = state => state.auditLogEntities.items;

export default auditLogEntities;
